"use strict";

exports.__esModule = true;
var _UhOh = require("./UhOh");
Object.keys(_UhOh).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UhOh[key]) return;
  exports[key] = _UhOh[key];
});